export const SET_VISIBILITY = "SET_VISIBILITY";
export const SET_FILE_DOWNLOADING = "SET_FILE_DOWNLOADING";
export const SET_DOWNLOADING_VISIBILITY = "SET_DOWNLOADING_VISIBILITY";
